import { render, staticRenderFns } from "./repair_return.vue?vue&type=template&id=3b6d84e6&"
import script from "./repair_return.vue?vue&type=script&lang=js&"
export * from "./repair_return.vue?vue&type=script&lang=js&"
import style0 from "./repair_return.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports